import useSWR from 'swr';

import { ENDPOINTS } from '@/api/endpoints';
import { getPreferredProvidersBySite } from '@/api/npi-preferred';

export const useGetPreferredNpiBySiteId = ({ site_id }: { site_id?: string }) => {
  const { data, mutate, isLoading, isValidating } = useSWR(
    site_id && [ENDPOINTS.NPI_PREFERRED, site_id],
    () => getPreferredProvidersBySite(site_id ?? ''),
    {
      revalidateOnFocus: false,
    }
  );

  return {
    data,
    loading: isLoading,
    refreshing: isValidating,
    refetch: mutate,
  };
};
